export const theme = {
  logoLink: {
    margin: '0 16px',    
  },
  logoLinkInv: {
    margin: '0 16px',
    filter: 'invert(1)',    
  },
  nameComponent: {
    display: {
      md: 'flex',
      sm: 'flex',
      xs: 'none',
    },
  },
};
